
const { document } = require('window');

const $ = require('jquery');
require('rgs-bootstrap');

const forms = require('page-common-forms');


$(document).on(
	'click.page-common.popup-form.data-api',
	'[data-toggle="page-common-popup-form"]',
	function (e) {
		const $this = $(this);

		e.preventDefault();

		const form = $this.attr('data-form');
		const productName = $this.attr('data-product');

		forms[form].popup(e, { productName });
	}
);

